export const routerPaths = {
  ROOT: "/",
  LANDING: "/landing",
  SETTINGS: "/settings",
  REGISTER: "/register",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/reset",
  VERIFY_EMAIL: "/verify-email",
  CONSENT: "/consent",
  SENSITIVE_DATA: "/sensitive-data",
};
